import { getValidToken, initiateLogin } from "./auth";

const API_BASE = import.meta.env.VITE_API_BASE ?? "";

async function authFetch(path: string, options: RequestInit = {}): Promise<Response> {
  let token = await getValidToken();
  if (!token) {
    initiateLogin().catch(console.error);
    throw new Error("Not authenticated");
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  if (res.status === 401) {
    // Token might have been revoked; clear and redirect
    initiateLogin().catch(console.error);
    throw new Error("Session expired");
  }

  return res;
}

export async function fetchMe(): Promise<{ login: string; name: string | null }> {
  const res = await authFetch("/api/me");
  if (!res.ok) throw new Error(`Failed to fetch user: ${res.status}`);
  return res.json() as Promise<{ login: string; name: string | null }>;
}

export interface SyncPayload {
  since: number;
  changes: {
    ideas: object[];
    messages: object[];
    projects: object[];
    repos: object[];
  };
}

export async function syncRequest(payload: SyncPayload): Promise<Response> {
  return authFetch("/api/sync", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function fileIssue(body: {
  repo: string;
  title: string;
  body: string;
  labels: string[];
  ideaId: string;
}): Promise<{ number: number; url: string }> {
  const res = await authFetch("/api/issues", {
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Failed to file issue: ${text}`);
  }
  return res.json() as Promise<{ number: number; url: string }>;
}
